import Vue from 'vue'
import VueSimpleMarkdown from 'vue-simple-markdown'

Vue.use(VueSimpleMarkdown)
